export { LockClosed as default } from './LockClosed';
